/*
 * Kenntnisnahme: "Fuer Maßanfertigungen besteht kein Widerrufsrecht"
 * (§ 312g Abs. 2 Nr. 1 BGB).
 *
 * Rechtlicher Rahmen: Die Checkbox ist eine *Kenntnisnahme*, kein Verzicht —
 * ein vorformulierter Verzicht auf das gesetzliche Widerrufsrecht waere nach
 * § 361 Abs. 2 BGB unwirksam. Der Ausschluss ergibt sich allein aus dem Gesetz;
 * die Bestaetigung dokumentiert nur, dass darauf hingewiesen wurde.
 *
 * Liquid rendert die Checkbox ausschliesslich dann, wenn der Warenkorb Artikel
 * ohne Widerrufsrecht enthaelt. Bei einem reinen Leinen- oder Gutschein-
 * Warenkorb fehlt sie — dann bleibt der Kaufen-Button unangetastet.
 *
 * Wichtig: Dawn ersetzt bei jeder Mengenaenderung das innerHTML von
 * #main-cart-footer bzw. des Drawers (cart.js -> getSectionsToRender). Dabei
 * gehen Checkbox-Zustand *und* Event-Listener verloren, und der frisch
 * gerenderte Checkout-Button ist nicht deaktiviert. Per innerHTML eingefuegte
 * <script>-Tags laufen nicht erneut, deshalb haengen wir uns an das
 * cartUpdate-Event, das Dawn nach dem Austausch publiziert.
 */

function initMassanfertigung(context) {
  const root = context || document;

  const checkbox = root.querySelector('#massanfertigung-accept, #massanfertigung-accept-drawer');
  const checkoutBtn = root.querySelector('[name="checkout"]');
  const dynamicButtons = root.querySelector('.cart__dynamic-checkout-buttons');

  if (!checkbox || !checkoutBtn) return;

  // Nach einem Re-Render ist das Markup neu, nach anderen Events ggf. nicht.
  if (checkbox.dataset.gateBound === 'true') return;
  checkbox.dataset.gateBound = 'true';

  const apply = (accepted) => {
    checkoutBtn.disabled = !accepted;
    if (dynamicButtons) dynamicButtons.style.display = accepted ? 'block' : 'none';
  };

  apply(checkbox.checked);

  checkbox.addEventListener('change', () => {
    const accepted = checkbox.checked;
    apply(accepted);
    recordAttribute(accepted);
  });
}

/*
 * Haelt die Bestaetigung als Warenkorb-Attribut fest, damit sie in der
 * Bestellung auftaucht. Ein Fehlschlag blockiert den Kauf bewusst *nicht*:
 * der Hinweis wurde angezeigt und bestaetigt, der gesetzliche Ausschluss haengt
 * nicht an diesem Attribut. Es waere unverhaeltnismaessig, wegen eines
 * Netzwerkfehlers den Checkout zu sperren — wir versuchen es einmal erneut.
 */
async function recordAttribute(accepted, attempt = 1) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'Maßanfertigung akzeptiert': accepted ? 'Ja' : 'Nein' },
      }),
    });
    if (!response.ok) throw new Error(`cart/update.js antwortete ${response.status}`);
  } catch (error) {
    if (attempt < 2) {
      recordAttribute(accepted, attempt + 1);
      return;
    }
    console.error('[massanfertigung] Warenkorb-Attribut konnte nicht gespeichert werden', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initMassanfertigung(document);

  // pubsub.js und constants.js liegen als defer im <head> und sind hier bereit.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => initMassanfertigung(document));
  }
});
